import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';

import * as ROUTES from '../../constants/routes';
import Button from '../Button';

import styles from './ManualSearchForm.module.css';

const ManualSearchForm = props => {
  const {variant, initialQuery, autoFocus, onSubmitted} = props;
  const history = useHistory();
  const location = useLocation();
  const syncWith = initialQuery || '';
  const [query, setQuery] = useState(syncWith);

  useEffect(() => {
    setQuery(syncWith);
  }, [syncWith]);

  const formStyles = variant === 'page'
    ? `${styles.Form} ${styles.Page}`
    : `${styles.Form} ${styles.Sidebar}`;

  const buttonStyle = variant === 'sidebar' ? {width: '100%'} : undefined;

  const handleSubmit = (event) => {
    event.preventDefault();
    const next = query.trim();
    if (!next) return;

    // Already at the destination, so a push would only stack a duplicate history
    // entry and re-scroll the results we are already showing.
    if (location.search !== `?q=${encodeURIComponent(next)}`) {
      history.push(`${ROUTES.SEARCH}?q=${encodeURIComponent(next)}`);
    }

    if (onSubmitted) onSubmitted();
  };

  return (
    <form className={formStyles} role='search' onSubmit={handleSubmit}>
      <input
        className={styles.Input}
        type='search'
        name='q'
        value={query}
        aria-label='Search the manual'
        placeholder='Search the manual'
        autoFocus={autoFocus}
        onChange={event => setQuery(event.target.value)}
      />
      <Button type='submit' fontSize='0.9rem' style={buttonStyle}>Search</Button>
    </form>
  );
};

ManualSearchForm.defaultProps = {
  variant: 'sidebar',
  initialQuery: ''
};

export default ManualSearchForm;
